<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">
                <el-form-item label="订单名称：" prop="order_no" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.order_no" style="width:175px" />
                </el-form-item>
                <el-form-item label="客户名称:" prop="customer_name" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.customer_name" style="width:175px" />
                </el-form-item>
                <el-form-item label="销售人员:" prop="ext_01" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.ext_01" style="width:175px" />
                </el-form-item>
                <el-form-item label="订单状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择状态">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="草稿" value="0"></el-option>
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="生效中" value="2"></el-option>
                    <el-option label="已终止" value="3"></el-option>
                    <el-option label="已到期" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>

              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row>
        <!-- 新增按钮 -->
        <el-button type="success" icon="el-icon-plus" size="small" plain style="margin-left:8px;" class="fr"
                   @click="handleCreate">
          新增订单
        </el-button>
      </el-row>
      <el-row class="main-table">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
          <el-table-column fixed  prop="order_no" label="订单名称" width="260" show-overflow-tooltip />
          <el-table-column  prop="customer_name" label="客户名称" width="180px"  show-overflow-tooltip/>
          <el-table-column  prop="ext_01" label="销售人员" width="120px"  show-overflow-tooltip/>
          <el-table-column prop="resource_type" label="资源类型" width="180" />
          <el-table-column prop="order_type" label="订单类型" width="100" align="center">
            <template v-slot="scope">
                <el-tag :type="getformatOrderType(scope.row.order_type)">
                {{ formatOrderType(scope.row.order_type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="订单状态" width="100" align="center">
              <template v-slot="scope">
                <el-tag :type="getformatStatus(scope.row.status)">
                {{ formatStatus(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="billing_day" label="账单日" width="75"  align="center" />
          <el-table-column prop="dev_number" label="设备数" width="75" align="center" />
          <el-table-column prop="delivered_number" label="已交付" width="75" align="center" />
          <el-table-column prop="total_price" label="总价" width="120" align="right" :formatter="formatAmount" />
          <el-table-column prop="currency" label="货币类型" width="100" align="center" />
          <el-table-column prop="starting_time" label="订单开始" width="100" :formatter="formatDateCell" />
          <el-table-column prop="end_time" label="订单结束" width="100" :formatter="formatDateCell" />
          <el-table-column fixed="right" header-align="left" align="left" show-overflow-tooltip min-width="240" label="操作">
            <template v-slot="scope">
                <el-button
                type="text"
                size="mini"
                @click="orderShowDetails(scope.row)">详情</el-button>
                <el-button
                type="text"
                size="mini"
                @click="editRegion(scope.row)">编辑</el-button>
                <el-button
                type="text"
                size="mini"
                @click="orderDelivery(scope.row)">交付管理</el-button>
                <el-button
                type="text"
                size="mini"
                @click="billRegion(scope.row)">生成账单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 生成账单弹窗 -->
    <el-dialog
      title="生成账单"
      :visible.sync="billDialogVisible"
      width="400px"
      @close="handleBillDialogClose"
      :close-on-click-modal="false"
    >
      <el-form :model="billForm" :rules="billRules" ref="billForm" label-width="100px">
        <el-form-item label="订单ID" prop="id">
          <el-input v-model="billForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="计费月份" prop="bill_month">
          <el-date-picker
            v-model="billForm.bill_month"
            type="month"
            placeholder="选择年月"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="billDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBillForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增组件 -->
    <create-provider ref="createProvider" @success="getTableData"></create-provider>
     <!-- 编辑组件 -->
    <edit-provider ref="editProvider" @success="getTableData"></edit-provider>
  </d2-container>

</template>
<script>
import CreateProvider from './CreateOrder.vue'; //
import EditProvider from './EditOrder.vue'; // 引入编辑组件
import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'
import { MessageBox } from 'element-ui';

export default {
  name: "allns",
  // mixins: [
  //   commonListMixin
  // ],
  components: {
    topLine,
    CreateProvider,
    EditProvider, // 注册组件
  },
  data() {
    return {
      pageTitle: "订单管理",
      labelWidth: '120px',
      tableDataApi: '/api-30216/api/orders',
      searchForm: {
        order_no: '',
        customer_name: '',
        ext_01: '',
        status:'',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: [],
      billDialogVisible: false,
      billForm: {
        id: '',
        bill_month: ''
      },
      billRules: {
        bill_month: [
          { required: true, message: '请选择计费月份', trigger: 'change' }
        ]
      },
      searchDebounceTimer: null,
    }
  },
  mounted () {
    this.loadParams();
     // 监听回车键
    document.addEventListener('keydown', this.handleEnterKey);
  },
  beforeDestroy() {
    // 组件销毁时移除监听，防止内存泄漏
    document.removeEventListener('keydown', this.handleEnterKey);
  },
  methods: {
     handleEnterKey(event) {
      if (event.key === 'Enter') {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => {
          this.handleSearch();
        }, 300);
      }
    },
    formatOrderType(value) {
      const map = {
        0: '开口',
        1: '闭口',
        2: '售前测试'
      };
      return map[value] || '-';
    },
    getformatOrderType(value) {
      switch (value) {
        case 0:
          return 'success';  // '开口合同' → 绿色
        case 1:
          return ;     // '闭口合同' → 红色
        case 2:
          return 'info';  // '售前测试' → 黄色
        default:
          return 'info';
      }
    },

    formatStatus(value) {
      const map = {
        0: '草稿',
        1: '待审核',
        2: '生效中',
        3: '已终止',
        4: '已到期'
      };
      return map[value] || '-';
    },
    getformatStatus(value) {
      switch (value) {
        case 0:
          return ;
        case 1:
          return ;
        case 2:
          return 'success';
        case 3:
          return 'info';
        case 4:
          return 'danger';
        default:
          return 'info';
      }
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    formatDateCell(row, column, cellValue) {
      let datetime = cellValue;
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      return Y + M + D;
    },
    formatAmount(row, column, cellValue) {
      // 处理 null/undefined
      if (cellValue == null || isNaN(cellValue)) return '0.00';

      // 转为数字，保留两位小数，千分位逗号
      const num = parseFloat(cellValue).toFixed(2);
      return Number(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    loadParams() {
      if(this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
      // 根据新的分页参数重新加载数据
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        order_no: '',
        customer_name: '',
        ext_01:'',
        status:'',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    //查询
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },
    // 新增方法
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        // 加判断，避免 clearValidate 报错
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },

    // 新增弹窗
    handleCreate() {
      this.$refs.createProvider.openDialog();
    },

    // 编辑弹窗
    editRegion(row) {
      this.$refs.editProvider.openDialog(row); // 将当前行数据传给 EditProvider
    },
    getTableData() {
      this.$axios.get(this.tableDataApi, {
       params: {
        order_no: this.searchForm.order_no,
        customer_name: this.searchForm.customer_name,
        ext_01: this.searchForm.ext_01,
        status: this.searchForm.status,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      }
      }).then(response => {
        console.log(response);
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },

    // 跳转详情页面
    orderShowDetails(row) {
      console.log(row.id)
      this.$router.push({
        path: '/orderShowDetails',
        query: {
          id: row.id,
          page: this.pagination.page,       // 当前页码
          pageSize: this.pagination.pageSize, // 页面大小
        }
      })
    },

    //orderDelivery 交付管理
    orderDelivery(row) {
      this.$router.push({
        path: '/orderDelivery',
        query: {
          id: row.id,
          page: this.pagination.page,       // 当前页码
          pageSize: this.pagination.pageSize, // 页面大小
        }
      })
    },

    /**
     * 获取默认账单月份（当前年月）
     */
    getDefaultBillMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 补零
      return `${year}-${month}`;
    },

    // 生成账单弹窗
    billRegion(row) {
      if (!row.id) {
        this.$message.error('数据异常：缺少ID');
        return;
      }

      this.billForm.id = row.id; // 确保这里拿到的是 UUID 字符串
      this.billForm.bill_month = this.getDefaultBillMonth();
      this.billDialogVisible = true;
    },
    submitBillForm() {
      this.$refs.billForm.validate(valid => {
        if (!valid) return;

        const { id, bill_month } = this.billForm;

        // 安全性校验
        if (!id) {
          this.$message.error('无效的订单ID');
          return;
        }

        MessageBox.confirm(`确定生成 【${bill_month}】 的账单吗？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.loading = true;

          // ✅ 正确拼接 URL：id 作为路径参数
          this.$axios.get(`/api-30216/api/orders/generate_bill/${id}`, {
            params: { bill_month }  // bill_month 作为查询参数
          })
            .then(res => {
              if (res.code === 200 || res.success) {
                this.$message.success('账单生成成功！');
                this.getTableData();           // 刷新列表
                this.billDialogVisible = false; // 关闭弹窗
              } else {
                this.$message.error(res.msg || '账单生成失败');
              }
            })
            .catch(err => {
              const response = err.response;
              const serverMsg = response && response.data && response.data.msg;
              const errorMsg = serverMsg || '网络错误，请稍后重试';
              this.$message.error(errorMsg);
            })
            .finally(() => {
              this.loading = false;
            });
        }).catch(() => {
          this.$message.info('已取消操作');
        });
      });
    },
    handleBillDialogClose() {
      this.$refs.billForm.resetFields();
    },

  }
}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
